import {
  createDashboardStore,
  createMergeDashboardState,
  formatInt,
  formatPct,
  localeForLanguage,
  type DashboardBoardState,
  type DashboardNumberMode,
} from "../../../shared/dashboard/dashboardStore"

export { formatInt, formatPct, localeForLanguage }
export type { DashboardNumberMode }

export type DashboardWidgetKey =
  | "coverage"
  | "frameworks"
  | "inReview"
  | "outstanding"
  | "replyQuality"
  | "handedBack"

export const DEFAULT_WIDGET_ORDER: DashboardWidgetKey[] = [
  "coverage",
  "frameworks",
  "inReview",
  "outstanding",
  "replyQuality",
  "handedBack",
]

export type SupplierDashboardState = DashboardBoardState<DashboardWidgetKey>

export const useSupplierDashboardStore =
  createDashboardStore<DashboardWidgetKey>({
    persistKey: "mc-supplier-dashboard",
    defaultOrder: DEFAULT_WIDGET_ORDER,
  })

/**
 * Standalone merge fn re-exported for direct unit testing / any caller that
 * imported it before the store became a factory instance. Bound to this
 * studio's DEFAULT_WIDGET_ORDER — behavior is unchanged from before the
 * shared-layer promotion.
 */
export const mergeDashboardState =
  createMergeDashboardState(DEFAULT_WIDGET_ORDER)
